import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=8d790f2c&scoped=true&"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=8d790f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d790f2c",
  null
  
)

export default component.exports